import { Component } from "@angular/core";
import {MachineManagerService} from "../../../../services/machine-manager.service";
import {RealtimeState} from "../../../../model/machine.model";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {ProcessReport} from "../../../../model/reports.model";

@Component({
  selector: "machine-realtime",
  templateUrl: "./realtime.component.html",
  styleUrls: ["./realtime.component.css"]
})
export class RealtimeComponent {

  constructor(
    private machineManager: MachineManagerService,
    private viewManager: ViewManagerService,
  ) {
  }

  getMachine() {
    return this.machineManager.machine;
  }

  getRealtime() {
    return this.machineManager.machine.realtime;
  }

  run(rs: RealtimeState) {
    let batch = this.machineManager?.machine?.batch ?? "";
    this.machineManager.realtimeRun(batch, rs.channel);
    this.viewManager.navigate(["admin/dashboard"]);
  }

  cancel(rs: RealtimeState) {
    this.machineManager.realtimeCancel(rs.channel);
    this.viewManager.navigate(["admin/dashboard"]);
  }

  statusClass(report: ProcessReport) {
    if (report.status == "SUCCESS") {
      return "success";
    } else if (report.status == "RUNNING") {
      return "running";
    } else if (report.status == "ERRORS") {
      return "errors";
    } else if (report.status == "NEW") {
      return "new";
    } else if (report.status == "DONE") {
      return "done";
    }
    return "disabled";
  }
}
